export const ENVIRONMENT_IS_TEST = typeof __TEST__ !== "undefined" && !!__TEST__;
export const ENVIRONMENT_IS_WEB = !ENVIRONMENT_IS_TEST && typeof window !== "undefined" && window.document !== undefined; /* && !window.document.hidden */
export const ENVIRONMENT_IS_WORKER = !ENVIRONMENT_IS_TEST && typeof importScripts === "function";
export function assertIsWorker() {
    if (ENVIRONMENT_IS_TEST)
        return;
    if (!ENVIRONMENT_IS_WORKER) {
        throw new Error(`This module should be in worker`);
    }
}
export function assertIsInWorker(aWorkerId) {
    if (ENVIRONMENT_IS_TEST)
        return;
    assertIsWorker();
    if (self.name !== aWorkerId && self.workerId !== aWorkerId) {
        throw new Error(`This module should be in worker "${aWorkerId}"`);
    }
}
export function assertIsWeb(moduleName) {
    if (ENVIRONMENT_IS_TEST)
        return;
    if (!ENVIRONMENT_IS_WEB) {
        throw new Error(`[environment] ${moduleName} should be in main thread but is used in the worker ${self.name}`);
    }
}
